import { createAsyncThunk } from '@reduxjs/toolkit';
import getResourceDataOfProjectSpecificFeature from '../services/getResourcesDataOfProjectSpecificFeature';
export const loadResourcesDataOfProjectSpecificFeature = createAsyncThunk(
  'resources/loadResourcesDataOfProjectSpecificFeature',
  async (projectId) => {
    const response = await getResourceDataOfProjectSpecificFeature(projectId);
    return response;
  }
);
